const nremtResponsiveAssessmentLayout = {
  header: [
    { key: 'lead', label: '', colSpan: 1 },
    { key: 'objectives', label: 'STUDENT OBJECTIVES', colSpan: 1 },
    { key: 'prompt', label: 'INSTRUCTOR PROMPT', colSpan: 1 },
    { key: 'score', label: 'SCORE', colSpan: 1 }
  ],
  rows: [
    { type: 'section', id: 'scene-size-up', title: 'SCENE SIZE-UP' },
    { type: 'objective', id: 'scene-safety', text: 'Scene Safety', promptId: 'scene-safety', scoreId: 'scene-safety-score', mergeLeadIntoObjective: true },
    { type: 'objective', id: 'bsi-ppe', text: 'BSI/PPE', promptId: 'bsi-ppe', scoreId: 'bsi-ppe-score', mergeLeadIntoObjective: true },
    { type: 'objective', id: 'noi-moi', text: 'Nature of Illness/Mechanism of Injury', promptId: 'noi-moi', scoreId: 'noi-moi-score', mergeLeadIntoObjective: true },
    { type: 'objective', id: 'number-of-patients', text: 'Number of Patients', promptId: 'number-of-patients', scoreId: 'number-of-patients-score', mergeLeadIntoObjective: true },
    { type: 'objective', id: 'additional-resources', text: 'Need for Additional Resources', promptId: 'additional-resources', scoreId: 'additional-resources-score', mergeLeadIntoObjective: true },
    { type: 'objective', id: 'spinal-precautions', text: 'Need for Spinal Precautions', promptId: 'spinal-precautions', scoreId: 'spinal-precautions-score', mergeLeadIntoObjective: true },

    { type: 'section', id: 'primary-assessment', title: 'PRIMARY ASSESSMENT' },
    { type: 'subsection', id: 'loc-heading', title: 'LOC' },
    {
      type: 'objective',
      id: 'general-impression',
      text: 'General Impression',
      promptId: 'general-impression',
      scoreId: 'general-impression-score'
    },
    {
      type: 'objectiveWithNote',
      id: 'loc-avpu',
      text: 'Alert - Verbal - Pain - Unresponsive',
      textStyle: 'italic',
      objectiveAlign: 'center',
      exclusiveOptions: [
        { id: 'loc-avpu-a', label: 'A' },
        { id: 'loc-avpu-v', label: 'V' },
        { id: 'loc-avpu-p', label: 'P' },
        { id: 'loc-avpu-u', label: 'U' }
      ],
      note: 'Ø  If the patient is alert, proceed to mental status',
      noteMergeLead: true,
      noteColSpan: 3,
      noteBreaksSubsection: true,
      promptId: 'loc-avpu',
      scoreId: 'loc-avpu-score'
    },
    { type: 'subsection', id: 'mental-status-heading', title: 'Mental status' },
    {
      type: 'checkboxRow',
      id: 'mental-status',
      items: [
        { id: 'mental-person', text: 'Person', inputId: 'mental-person-input' },
        { id: 'mental-place', text: 'Place', inputId: 'mental-place-input' },
        { id: 'mental-time', text: 'Time', inputId: 'mental-time-input' }
      ],
      mergeObjectiveWithPrompt: true,
      objectiveAlign: 'center',
      scoreId: 'mental-status-score'
    },
    {
      type: 'checkboxRow',
      id: 'mental-status-cc',
      items: [
        { id: 'mental-cc', text: 'C/C', inputId: 'mental-cc-input' }
      ],
      promptId: 'mental-status-cc-prompt',
      scoreId: 'mental-status-cc-score'
    },
    { type: 'subsection', id: 'airway-heading', title: 'Airway' },
    { type: 'objective', id: 'airway-sounds', text: 'Listen for Abnormal Sounds', promptId: 'airway-sounds', scoreId: 'airway-sounds-score' },
    { type: 'objective', id: 'airway-patent', text: 'Determine if the Airway is Patent', promptId: 'airway-patent', scoreId: 'airway-patent-score' },
    { type: 'objective', id: 'airway-maneuver', text: 'Determine need for Airway Maneuver or Adjunct', promptId: 'airway-maneuver', scoreId: 'airway-maneuver-score' },
    { type: 'subsection', id: 'breathing-heading', title: 'Breathing' },
    { type: 'objective', id: 'breathing-rate', text: 'Determine Breathing Rate (Quick Rate)', promptId: 'breathing-rate', scoreId: 'breathing-rate-score' },
    { type: 'objective', id: 'breathing-adequate', text: 'Determine if Breathing Adequate', promptId: 'breathing-adequate', scoreId: 'breathing-adequate-score' },
    { type: 'objective', id: 'oxygen-decision', text: 'Determine the Need to Administer or Withhold Oxygen', promptId: 'oxygen-decision', scoreId: 'oxygen-decision-score' },
    { type: 'subsection', id: 'circulation-heading', title: 'Circulation' },
    { type: 'objective', id: 'major-bleeding', text: 'Check for Major Bleeding', promptId: 'major-bleeding', scoreId: 'major-bleeding-score' },
    {
      type: 'checkboxRow',
      id: 'pulse-check',
      items: [
        { id: 'pulse-rate', text: 'Rate', selectId: 'pulse-rate-select', options: ['', 'Normal', 'Fast', 'Slow', 'Absent'] },
        { id: 'pulse-rhythm', text: 'Rhythm', selectId: 'pulse-rhythm-select', options: ['', 'Regular', 'Irregular'] },
        { id: 'pulse-quality', text: 'Quality', selectId: 'pulse-quality-select', options: ['', 'Normal', 'Weak', 'Bounding', 'Absent'] }
      ],
      mergeObjectiveWithPrompt: true,
      objectiveAlign: 'center',
      scoreId: 'pulse-check-score'
    },
    {
      type: 'checkboxRow',
      id: 'skin-check',
      items: [
        { id: 'skin-color', text: 'Color', selectId: 'skin-color-select', options: ['', 'Normal', 'Pale', 'Cyanotic', 'Flushed', 'Jaundice'] },
        { id: 'skin-temperature', text: 'Temperature', selectId: 'skin-temp-select', options: ['', 'Normal', 'Hot', 'Cool', 'Cold'] },
        { id: 'skin-moisture', text: 'Moisture', selectId: 'skin-moisture-select', options: ['', 'Normal', 'Dry', 'Moist', 'Diaphoretic'] }
      ],
      mergeObjectiveWithPrompt: true,
      objectiveAlign: 'center',
      scoreId: 'skin-check-score'
    },
    { type: 'subsection', id: 'decision-heading', title: 'Decision' },
    { type: 'objective', id: 'patient-priority', text: 'Determines Patient Priority (High or Low)', promptId: 'patient-priority', scoreId: 'patient-priority-score' },

    { type: 'section', id: 'secondary-assessment', title: 'SECONDARY ASSESSMENT' },
    { type: 'subsection', id: 'focused-exam-heading', title: 'Focused exam' },
    {
      type: 'objective',
      id: 'focused-exam',
      text: 'Examine Relevant Area(s)',
      checkboxId: 'focused-exam-checkbox',
      promptId: 'focused-exam-prompt',
      inputId: 'focused-exam-input',
      scoreId: 'focused-exam-score'
    },
    {
      type: 'subsection',
      id: 'pmh-heading',
      title: 'Past medical history',
      leadClassName: 'nremt-lead-subheading nremt-lead-subheading--ample'
    },
    {
      type: 'objective',
      id: 'sample-history-label',
      text: 'Allergies – Medications – Past History – Last Oral Intake – Events Leading',
      textStyle: ['italic', 'tiny'],
      className: 'nremt-letter-subheading nremt-objective-borderless',
      promptText: 'Onset – Provoke – Quality – Radiate – Severity – Time',
      promptTextStyle: ['italic', 'tiny']
    },
    {
      type: 'letterInputRow',
      id: 'sample-history',
      text: 'A',
      studentInputId: 'sample-history-a-input',
      checkboxId: 'sample-history-a-checkbox',
      promptId: 'sample-history-a-note',
      scoreId: 'sample-history-score',
      className: 'nremt-objective-borderless',
      promptCheckboxes: [
        { id: 'sample-history-opqrst-o', letter: 'O', text: 'Onset' }
      ]
    },
    {
      type: 'letterInputRow',
      id: 'sample-history-m',
      text: 'M',
      studentInputId: 'sample-history-m-input',
      checkboxId: 'sample-history-m-checkbox',
      promptId: 'sample-history-m-note',
      className: 'nremt-objective-borderless',
      promptCheckboxes: [
        { id: 'sample-history-opqrst-p', letter: 'P', text: 'Provoke' }
      ]
    },
    {
      type: 'letterInputRow',
      id: 'sample-history-p',
      text: 'P',
      studentInputId: 'sample-history-p-input',
      checkboxId: 'sample-history-p-checkbox',
      promptId: 'sample-history-p-note',
      className: 'nremt-objective-borderless',
      promptCheckboxes: [
        { id: 'sample-history-opqrst-q', letter: 'Q', text: 'Quality' }
      ]
    },
    {
      type: 'letterInputRow',
      id: 'sample-history-l',
      text: 'L',
      studentInputId: 'sample-history-l-input',
      checkboxId: 'sample-history-l-checkbox',
      promptId: 'sample-history-l-note',
      className: 'nremt-objective-borderless',
      promptCheckboxes: [
        { id: 'sample-history-opqrst-r', letter: 'R', text: 'Radiate' }
      ]
    },
    {
      type: 'letterInputRow',
      id: 'sample-history-e',
      text: 'E',
      studentInputId: 'sample-history-e-input',
      checkboxId: 'sample-history-e-checkbox',
      promptId: 'sample-history-e-note',
      className: 'nremt-objective-borderless',
      objectiveRowSpan: 3,
      promptCheckboxes: [
        { id: 'sample-history-opqrst-s', letter: 'S', text: 'Severity' }
      ]
    },
    {
      type: 'opqrstOnlyRow',
      id: 'sample-history-t-row',
      skipObjectiveCell: true,
      promptId: 'sample-history-t-note',
      promptCheckboxes: [
        { id: 'sample-history-opqrst-t', letter: 'T', text: 'Time' }
      ]
    },
    {
      type: 'opqrstOnlyRow',
      id: 'sample-history-other-row',
      skipObjectiveCell: true,
      promptId: 'sample-history-other-note',
      promptCheckboxes: [
        { id: 'sample-history-opqrst-other', letter: 'Other', text: 'Other' }
      ]
    },
    { type: 'subsection', id: 'vitals-heading', title: 'Vital signs' },
    {
      type: 'checkboxRow',
      id: 'vitals-row-1',
      items: [
        { id: 'vitals-bp', text: 'BP', inputId: 'vitals-bp-input' },
        { id: 'vitals-respiratory-rate', text: 'RR', inputId: 'vitals-rr-input' },
        { id: 'vitals-spo2', text: 'SPO2', inputId: 'vitals-spo2-input' },
        { id: 'vitals-gcs', text: 'GCS', inputId: 'vitals-gcs-input' }
      ],
      mergeObjectiveWithPrompt: true,
      objectiveAlign: 'center',
      scoreId: 'vitals-row-1-score'
    },
    {
      type: 'checkboxRow',
      id: 'vitals-row-2',
      items: [
        { id: 'vitals-heart-rate', text: 'HR', inputId: 'vitals-hr-input' },
        { id: 'vitals-lung-sounds', text: 'LS', inputId: 'vitals-ls-input' },
        { id: 'vitals-pupils', text: 'Pupils', inputId: 'vitals-pupils-input' },
        { id: 'vitals-bgl', text: 'BGL', inputId: 'vitals-bgl-input' }
      ],
      mergeObjectiveWithPrompt: true,
      objectiveAlign: 'center',
      scoreId: 'vitals-row-2-score'
    },
    {
      type: 'objective',
      id: 'field-impression',
      text: 'Field Impression and Treatment Plan',
      checkboxId: 'field-impression-checkbox',
      promptId: 'field-impression',
      scoreId: 'field-impression-score'
    },

    { type: 'section', id: 'reassessment', title: 'REASSESSMENT' },
    {
      type: 'objective',
      id: 'repeat-primary',
      text: 'Repeat Primary Assessment',
      promptId: 'repeat-primary',
      scoreId: 'repeat-primary-score',
      mergeLeadIntoObjective: true
    },
    {
      type: 'objective',
      id: 'evaluate-response',
      text: 'Evaluate Response to Treatment',
      promptId: 'evaluate-response',
      scoreId: 'evaluate-response-score',
      mergeLeadIntoObjective: true
    },
    {
      type: 'objective',
      id: 'repeat-vitals',
      text: 'Repeat Vital Signs and Look for Trends',
      promptId: 'repeat-vitals',
      scoreId: 'repeat-vitals-score',
      mergeLeadIntoObjective: true
    },
    {
      type: 'objective',
      id: 'reassess-frequency',
      text: 'Explain How Often to Reassess',
      promptId: 'reassess-frequency',
      scoreId: 'reassess-frequency-score',
      mergeLeadIntoObjective: true
    },
    {
      type: 'objective',
      id: 'radio-report',
      text: 'Provide Radio or Verbal Report',
      promptId: 'radio-report',
      scoreId: 'radio-report-score',
      mergeLeadIntoObjective: true
    }
  ]
};

export default nremtResponsiveAssessmentLayout;
